import { Graphics, Text } from "pixi.js";
import DisplayContainer from "./DisplayContainer";
import ButtonShapeProperties from "../types/ButtonShapeProperties";


export default class TextButton extends DisplayContainer {
    //--------------------------------------------------------------------------
    //
    //  Properties
    //
    //--------------------------------------------------------------------------

    //----------------------------------
    //  Private:
    //----------------------------------

    private bg: Graphics;
    private fontAlias: string;
    private fontColor: string;
    private fontSize: number;
    private shapeProps: ButtonShapeProperties;
    private text: string;
    private textField: Text;

    //--------------------------------------------------------------------------
    //
    //  Constructor
    //
    //--------------------------------------------------------------------------

    constructor(text: string, fontAlias = 'Arial') {
        super();
        this.text = text;
        this.fontAlias = fontAlias;
        this._init();
    }

    //--------------------------------------------------------------------------
    //
    //  Methods
    //
    //--------------------------------------------------------------------------

    //----------------------------------
    //  Private:
    //----------------------------------

    private _init(): void {
        this.fontSize = 120;
        this.fontColor = '#000000';
        this.shapeProps = new ButtonShapeProperties(
            '#CCCCCC',
            200,
            200,
            8,
            1,
            '#555555',
            1
        );
    }

    private addListeners(): void {
        this.onmouseout = this.handleRollout;
        this.onmouseover = this.handleRollover;
    }

    private createBg(): void {
        this.bg = new Graphics();
        this.bg.roundRect(
            this.shapeProps.x,
            this.shapeProps.y,
            this.shapeProps.width,
            this.shapeProps.height,
            this.shapeProps.radius
        );
        this.bg.fill(this.shapeProps.fillColor);
        this.bg.stroke({width:this.shapeProps.strokeThickness, color:this.shapeProps.fillColor});
        this.bg.alpha = this.shapeProps.alpha;
        this.addChild(this.bg);
    }

    private createTextField(): void {
        this.textField = new Text({
            text: this.text,
            style: { fontFamily: this.fontAlias, fontSize: this.fontSize, fill: this.fontColor },
        });
        this.textField.anchor.set(0.5);
        this.textField.x = this.width / 2;
        this.textField.y = this.height / 2;
        this.addChild(this.textField);
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private handleRollout = (event: any): void => {
        void 0;
    };

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private handleRollover = (event: any): void => {
        void 0;
    };

    private removeListeners(): void {
        this.onmouseout = null;
        this.onmouseover = null
    }

    //----------------------------------
    //  Public:
    //----------------------------------

    public create(): void {
        this.createBg();
        this.createTextField();
        this.cursor = 'pointer';
        this.addListeners();
        this.show();
        this.enable();
    }

    public destroy(): void {
        this.removeListeners();
        this.removeChildren();
    }
}
